import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { ClassChallenge } from "@/components/landing/ClassChallenge";
import { Pricing } from "@/components/landing/Pricing";
import { Impact } from "@/components/landing/Impact";
import { ShareBar } from "@/components/landing/ShareBar";
import { InstagramFeed } from "@/components/landing/InstagramFeed";
import { SocialProof } from "@/components/landing/SocialProof";
import { Footer } from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="app-root bg-white text-slate-900">
      <Navbar />
      <SocialProof />
      <main>
        <ClassChallenge />
        <Hero />
        <Marquee />
        <Pricing />
        <Impact />
        <ShareBar />
        <InstagramFeed />
      </main>
      <Footer />
    </div>
  );
}

export default App;
